var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Radio',{directives:[{name:"ok",rawName:"v-ok"}],staticClass:"radio",attrs:{"values":[ _vm.$t( 'Yes' ), _vm.$t( 'No' ) ],"value":( '' + _vm.value ) === 'true' ? _vm.$t( 'Yes' ) : _vm.$t( 'No' ),"disabled":_vm.disabled},on:{"input":_vm.set}})
}
var staticRenderFns = []

export { render, staticRenderFns }